import React from "react"
import { Route } from "react-router-dom"
import RedirectToLogin from "./redirect-to-login"

const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) => (
  <Route {...rest} render={(props) => (isAuthenticated ? <Component {...props} /> : <RedirectToLogin {...props} />)} />
)

export default PrivateRoute
